import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/useAuthStore';
import { useLoadingStore } from '../../stores/useLoadingStore';
import { carregarUsuario } from '../../services/authService';
import { useHourFilterStore } from '../../stores/useHourFilterStore';
import { useScreenStore } from '../../stores/useScreenStore';
import { requestHourRange } from '../../channels/monitorChannel';

const {
    startLoading,
    stopLoading
} = useLoadingStore.getState();

export function useAuthGuard() {

    const navigate = useNavigate();

    const user = useAuthStore(state => state.user);

    useEffect(() => {

        if (user) {

            const hourStore = useHourFilterStore.getState();

            const { screen } = useScreenStore.getState();

            if (screen === 'Filtros') {

                if (!hourStore.operationalContextInitialized) {
                    requestHourRange();
                }

                return;
            }

            hourStore.loadHourRange();

            return;
        }

        async function run() {

            startLoading('Validando usuário...', false);

            try {

                const result = await carregarUsuario();
                if(result?.status !== 200){
                    navigate('/login', { replace: true });
                }
                
            } finally {
                stopLoading(false);
            }           

        }

        run();

    }, [user, navigate]);

    return {
        hasUser: !!user
    };

}